import { NoMatchPage } from "components/NoMatchPage";
import { LoginRoute } from "pages/LoginRoute";
import { FC } from "react";
import { Route, Routes } from "react-router-dom";
import { Auth0Callback } from "./Auth0Callback";
import { Auth0Login } from "./Auth0Login";
import { LoginPage } from "./LoginPage";

const Router: FC = () => {
  return (
    <Routes>
      <Route index element={<LoginPage />} />
      <Route path="auth0login" element={<LoginRoute component={Auth0Login} />} />
      <Route path="auth0callback" element={<LoginRoute component={Auth0Callback} />} />
      <Route path="*" element={<NoMatchPage />} />
    </Routes>
  );
};
export default Router;
